import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var DiamondHalfIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M15.776 4c1.028 0 1.922.583 2.647 1.255l.153.145 3.503 3.693a3 3 0 01-.147 3.78l-.132.141-7.68 7.68-.036-.036-.054.12-.094.084-.097.08a3 3 0 01-3.818-.114l-.143-.135-7.68-7.68A3 3 0 011.81 9.25l.111-.158L5.476 5.4c.377-.406.733-.772 1.197-1.012.42-.216.882-.347 1.362-.38L8.275 4h7.5zm0 2h-3.777L12 19.572a.999.999 0 00.5-.134l.112-.075.094-.083 7.68-7.68.081-.092a1 1 0 00.085-1.102l-.073-.113L16.976 6.6l-.1-.12a1.5 1.5 0 00-.944-.472L15.776 6z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
DiamondHalfIcon.isCarinaIcon = true;
export default DiamondHalfIcon;
